import usePeriodLevels from "backend/hooks/model/usePeriodLevels";
import { t } from "i18next";
import * as conf from "qpr-base/configuration";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import React, { useEffect } from "react";
import TabsBar from "../components/TabsBar";
import FormikSelect from "./../form/FormikSelect";
import useFormStyles from "./themes";

const MeasurementDetailsForm = (props: {
  disabled?: boolean;
  setField: any;
  units: { id: string; name: string }[];
  valuesettingId: string;
  currentStartDate?: string;
  currentEndDate?: string;
  valuesettings: { id: string; name: string; typename: string }[];
  setVisiblePeriods?: (
    periodlevelId: string,
    startDate: string,
    endDate: string
  ) => void;
  unitId: string;
  isProject?: boolean;
  editing?: boolean;
}) => {
  const classes = useFormStyles();
  const ctx = useAppContext();

  const { data: periodLevels, isLoading: isLoadingPeriodLevels } =
    usePeriodLevels();
  const measurementCycleOptions = (periodLevels || []).map((level: any) => {
    return {
      title: level.name,
      value: level.id,
    };
  });

  useEffect(() => {
    props.setField("measureunitid", props.unitId || "");
  }, [props.unitId]);

  const valuesettingsConfig = conf.getKpiEditingViewValueSettings();

  const VALUESETTINGS = (props.valuesettings || [])
    .filter((vs) =>
      valuesettingsConfig.find((vsConfig) => vsConfig.name === vs.name)
    )
    .map((vs) => {
      return {
        title: t(`configtypes.${vs.name as string}`),
        value: vs.id as string,
      };
    });
  return (
    <>
      <h1 className={classes.formTitle}>{t("kpis.Measurement Details")}</h1>

      {props.isProject ? null : (
        <TabsBar
          name="measurementDetails.Position"
          label={t("Value Settings")}
          options={VALUESETTINGS}
          value={props.valuesettingId}
          disabled={props.disabled}
          handleFieldChange={(value: string) => {
            props.setField("valuesettingid", value);
          }}
        />
      )}

      <FormikSelect
        options={measurementCycleOptions}
        placeholder="Select Measurement Cycle"
        label={`${t("initiatives.Measurement Frequency")}`}
        name="periodlevelid"
        disabled={props.disabled}
        handleFieldChange={(value: string, field: string) => {
          if (props.setVisiblePeriods) {
            props.setVisiblePeriods(
              value,
              props.currentStartDate || "",
              props.currentEndDate || ""
            );
          }
          props.setField("periodlevelid", value);
        }}
      />

      <FormikSelect
        options={
          props.units
            .filter((unit) => unit.name !== "Date")
            .map((unit) => ({
              title: t(unit.name),
              value: unit.id,
            })) || []
        }
        placeholder="Select Measurement Unit"
        label={
          props.isProject
            ? t("initiatives.Budget Currency")
            : t("kpis.Measurement Unit")
        }
        name="measureunitid"
        disabled={props.disabled}
        handleFieldChange={(value: any, field: any) => {
          props.setField("measureunitid", value);
        }}
      />
    </>
  );
};
export default MeasurementDetailsForm;
